import { API } from 'aws-amplify'
import keyBy from 'lodash/keyBy'

import * as types from './action-types'

export const load = () => dispatch =>
  API.get('transcriptions', '/transcriptions')
    .catch(e => {
      console.warn(e)
      return {}
    })
    .then(transcriptions =>
      dispatch({
        type: types.LOADED,
        payload: { data: keyBy(transcriptions, 'transcriptionId') }
      })
    )

export const get = transcriptionId => dispatch => {
  dispatch(getRequest())

  return API.get('transcriptions', `/transcriptions/${transcriptionId}`)
    .then(transcription => {
      dispatch(getSuccess(transcription))
    })
    .catch(e => {
      console.error(e)
      dispatch(getFailure())
    })
}

export const create = data => dispatch => {
  dispatch(createRequest())

  return API.post('transcriptions', '/transcriptions', {
    body: {
      title: data.title,
      s3InputUrl: data.s3InputUrl,
      s3Key: data.s3Key,
      format: data.format,
      channelIdentification: data.channelIdentification,
      speakerIdentification: data.speakerIdentification,
      numSpeakers: data.numSpeakers,
      language: 'en-US'
    }
  })
    .then(transcription =>
      API.post(
        'transcriptions',
        `/transcriptions/${transcription.transcriptionId}/start`
      )
    )
    .then(transcription => {
      dispatch(createSuccess(transcription))
    })
    .catch(e => {
      console.error(e)
      dispatch(createFailure(e.message))
    })
}

export const update = (transcriptionId, data) => dispatch => {
  dispatch(updateRequest())

  return API.put('transcriptions', `/transcriptions/${transcriptionId}`, {
    body: data
  })
    .then(transcription => dispatch(updateSuccess(transcription)))
    .catch(e => {
      console.error(e)
      dispatch(updateFailure(e.message))
    })
}

export const del = transcriptionId => dispatch => {
  dispatch(delRequest())
  return API.del('transcriptions', `/transcriptions/${transcriptionId}`)
    .then(() => dispatch(delSuccess(transcriptionId)))
    .catch(e => {
      console.error(e)
      dispatch(delFailure())
    })
}

const getRequest = () => ({
  type: types.GET_REQUEST
})

const getSuccess = transcription => ({
  type: types.GET_SUCCESS,
  payload: { transcription }
})

const getFailure = error => ({
  type: types.GET_FAILURE,
  payload: { error }
})

const createRequest = () => ({
  type: types.CREATE_REQUEST
})

const createSuccess = transcription => ({
  type: types.CREATE_SUCCESS,
  payload: { transcription }
})

const createFailure = error => ({
  type: types.CREATE_FAILURE,
  payload: { error }
})

const updateRequest = () => ({
  type: types.UPDATE_REQUEST
})

const updateSuccess = transcription => ({
  type: types.UPDATE_SUCCESS,
  payload: { transcription }
})

const updateFailure = error => ({
  type: types.UPDATE_FAILURE,
  payload: { error }
})

const delRequest = () => ({
  type: types.DEL_REQUEST
})

const delSuccess = transcriptionId => ({
  type: types.DEL_SUCCESS,
  payload: { transcriptionId }
})

const delFailure = () => ({
  type: types.DEL_FAILURE
})



// WEBPACK FOOTER //
// ./src/redux/transcriptions/actions.js